"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
function memoize(f, resolver) {
    var memoized = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = typeof resolver === "function" ? resolver.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false)) : args[0];
        var _self = memoized;
        if (_self.cache === undefined) {
            _self.cache =
                key != null && typeof key === "object" ? new WeakMap() : new Map();
        }
        var cache = _self.cache;
        if (!(cache instanceof WeakMap || cache instanceof Map)) {
            throw new TypeError("`cache` should only use `WeakMap`, `Map`");
        }
        if (cache.has(key)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return cache.get(key);
        }
        var result = f.apply(void 0, tslib_1.__spreadArray([], tslib_1.__read(args), false));
        cache.set(key, result);
        return result;
    };
    return memoized;
}
exports.default = memoize;
//# sourceMappingURL=memoize.js.map